import { TFunction } from 'react-i18next';
import { Dispatch } from 'redux';
import { GlobalNotificationTypes } from '../enums/GlobalNotificationTypes';
import { spawnGlobalNotification } from '../state/global-notifications/asyncActions';

function addBusinessDays(givenDate: Date, numberOfDays: number) {
  const date = new Date(givenDate.getTime());
  const day = date.getDay();
  date.setDate(date.getDate() + numberOfDays - (day === 6 ? 1 : -(+!day - 1)) + Math.floor((numberOfDays - 1 + (day % 6 || 1)) / 5) * 2);
  return date;
}

export const isBookingDateValid = (
  bookingDeadline: number,
  deliveryDate: string,
  dispatch: Dispatch<any>,
  t: TFunction<'translation', undefined>
) => {
  let valid = true;
  const today = new Date();
  const result = addBusinessDays(today, bookingDeadline);
  const deadlineDate = new Date(result);

  if (new Date(deliveryDate) > deadlineDate) {
    dispatch(
      spawnGlobalNotification({
        type: GlobalNotificationTypes.Error,
        message: t('booking.validation.bookingDeadline.message')
      })
    );
    valid = false;
  }

  return valid;
};
